export const starFieldBackgroundProps = [
  {
    "cx": "59.537901564404926%",
    "cy": "42.58585322979278%",
    "r": 0.5192877581423992,
    "animationDelay": "1.0302420587686678s"
  },
  {
    "cx": "48.275355080932194%",
    "cy": "89.00882811119499%",
    "r": 1.3365359463876836,
    "animationDelay": "2.1564066490123626s"
  },
  {
    "cx": "26.697452597117287%",
    "cy": "65.02100882430237%",
    "r": 0.508026222312317,
    "animationDelay": "0.9335085956398481s"
  },
  {
    "cx": "65.01922052847%",
    "cy": "81.18576139330746%",
    "r": 1.1461691911410707,
    "animationDelay": "1.2367293954608771s"
  },
  {
    "cx": "62.48140106444578%",
    "cy": "49.42978463002235%",
    "r": 1.2681616635833448,
    "animationDelay": "2.216021746631701s"
  },
  {
    "cx": "47.00546908303656%",
    "cy": "61.09624604148085%",
    "r": 1.5347447986567886,
    "animationDelay": "3.6599055481537937s"
  },
  {
    "cx": "45.69610948689065%",
    "cy": "54.39613186046055%",
    "r": 1.9022338508510508,
    "animationDelay": "1.6939009415726136s"
  },
  {
    "cx": "4.028126022109113%",
    "cy": "76.22931747757224%",
    "r": 1.3612368150519005,
    "animationDelay": "4.135464137414866s"
  },
  {
    "cx": "57.43973042331909%",
    "cy": "60.098789326297755%",
    "r": 0.8034608762996934,
    "animationDelay": "4.569263616305443s"
  },
  {
    "cx": "97.94365319032718%",
    "cy": "11.360133362706826%",
    "r": 0.8498367416512969,
    "animationDelay": "0.9710115731950997s"
  },
  {
    "cx": "62.90726266038702%",
    "cy": "22.12794609810398%",
    "r": 1.422363761421012,
    "animationDelay": "0.07756152706615227s"
  },
  {
    "cx": "78.38300868087673%",
    "cy": "99.52447663994381%",
    "r": 0.9205802876847339,
    "animationDelay": "0.04736228703817624s"
  },
  {
    "cx": "28.534055345438492%",
    "cy": "75.97655696427512%",
    "r": 0.8718106216011766,
    "animationDelay": "4.5045471835433215s"
  },
  {
    "cx": "22.176407327660485%",
    "cy": "57.975009551847975%",
    "r": 1.5307217859292144,
    "animationDelay": "4.735233657882777s"
  },
  {
    "cx": "85.20109092424264%",
    "cy": "58.77310922830637%",
    "r": 1.01509233249941,
    "animationDelay": "2.425770009125362s"
  },
  {
    "cx": "17.347741485473513%",
    "cy": "82.31534375228074%",
    "r": 1.451654618180025,
    "animationDelay": "3.0368613723545987s"
  },
  {
    "cx": "38.781449219296896%",
    "cy": "23.309544399475325%",
    "r": 0.8616829030122836,
    "animationDelay": "1.7284282259865302s"
  },
  {
    "cx": "93.44217232183038%",
    "cy": "44.82623066461693%",
    "r": 1.3527845827572489,
    "animationDelay": "4.6339786379567025s"
  },
  {
    "cx": "87.44869991616689%",
    "cy": "77.99568126051481%",
    "r": 0.8716753398364528,
    "animationDelay": "1.3926170755503153s"
  },
  {
    "cx": "10.38965446554978%",
    "cy": "97.97871890600767%",
    "r": 1.3339685970844566,
    "animationDelay": "0.6662817825678269s"
  },
  {
    "cx": "30.599187412849172%",
    "cy": "79.21124280250784%",
    "r": 1.1749666274792476,
    "animationDelay": "2.1971111221862505s"
  },
  {
    "cx": "81.73880363102795%",
    "cy": "98.35048145524053%",
    "r": 0.8441848272206615,
    "animationDelay": "2.9074742404183427s"
  },
  {
    "cx": "34.760880033313725%",
    "cy": "13.022219271511371%",
    "r": 1.9742845014296355,
    "animationDelay": "3.056296274747475s"
  },
  {
    "cx": "26.560212862698094%",
    "cy": "19.769512726946047%",
    "r": 0.7486646215478984,
    "animationDelay": "0.14557249749910128s"
  },
  {
    "cx": "92.64290035611931%",
    "cy": "69.23162170672306%",
    "r": 1.1623522358296792,
    "animationDelay": "4.2467487449142585s"
  },
  {
    "cx": "5.257328090605373%",
    "cy": "26.525421067404654%",
    "r": 1.7656090139143719,
    "animationDelay": "4.649803922596789s"
  },
  {
    "cx": "11.93038408601641%",
    "cy": "48.06308204165211%",
    "r": 1.825171028959224,
    "animationDelay": "4.637407931260439s"
  },
  {
    "cx": "29.6236189345684%",
    "cy": "71.17256003161361%",
    "r": 1.536960119226488,
    "animationDelay": "4.535557587975424s"
  },
  {
    "cx": "26.055909435151502%",
    "cy": "51.285590686648355%",
    "r": 0.5157668762646553,
    "animationDelay": "0.9944413301154598s"
  },
  {
    "cx": "71.52270708530592%",
    "cy": "46.61602911752236%",
    "r": 1.5159954595148553,
    "animationDelay": "2.7015056097526244s"
  },
  {
    "cx": "7.9773926803082595%",
    "cy": "28.399942374628353%",
    "r": 0.7232870124961357,
    "animationDelay": "3.7882725506842743s"
  },
  {
    "cx": "1.663755051415916%",
    "cy": "27.994865277499947%",
    "r": 0.5646586331137338,
    "animationDelay": "3.732250304212319s"
  },
  {
    "cx": "55.44850329640341%",
    "cy": "58.91743921247874%",
    "r": 1.495313531008356,
    "animationDelay": "3.6100110594722343s"
  },
  {
    "cx": "36.006716505947864%",
    "cy": "77.49929589299265%",
    "r": 1.769797669952872,
    "animationDelay": "3.2271425330826595s"
  },
  {
    "cx": "31.39600967170768%",
    "cy": "74.4295274808146%",
    "r": 0.5698586515331199,
    "animationDelay": "4.358598837419167s"
  },
  {
    "cx": "81.6553953010791%",
    "cy": "30.157235408017492%",
    "r": 0.8210408689490742,
    "animationDelay": "3.700803980488759s"
  },
  {
    "cx": "11.754293257830284%",
    "cy": "70.75605496329958%",
    "r": 1.106635355908713,
    "animationDelay": "1.707842065621461s"
  },
  {
    "cx": "15.33734908920139%",
    "cy": "24.026278299356573%",
    "r": 1.6665035843688725,
    "animationDelay": "1.353506892559122s"
  },
  {
    "cx": "10.057015526269296%",
    "cy": "14.073103338254178%",
    "r": 1.9650624001121875,
    "animationDelay": "4.852305144297092s"
  },
  {
    "cx": "15.335454290391603%",
    "cy": "48.64913987562489%",
    "r": 1.9477029458095778,
    "animationDelay": "2.6569598996196895s"
  },
  {
    "cx": "93.77579163020606%",
    "cy": "63.249860422178436%",
    "r": 0.5431303391154232,
    "animationDelay": "2.2563724713280884s"
  },
  {
    "cx": "12.200217502220045%",
    "cy": "78.85391290195997%",
    "r": 1.8145665908708113,
    "animationDelay": "2.6144592006659373s"
  },
  {
    "cx": "69.69488672575072%",
    "cy": "11.089064731697329%",
    "r": 1.1546390217453477,
    "animationDelay": "4.503624190830032s"
  },
  {
    "cx": "3.1962812417141606%",
    "cy": "76.26868698359115%",
    "r": 1.4861698248708932,
    "animationDelay": "0.6851758258341645s"
  },
  {
    "cx": "9.589214056712203%",
    "cy": "21.183300653219117%",
    "r": 0.5214471536159329,
    "animationDelay": "4.825601434583825s"
  },
  {
    "cx": "64.07462734434624%",
    "cy": "75.1155445058413%",
    "r": 1.0399617946837751,
    "animationDelay": "1.392652902590994s"
  },
  {
    "cx": "50.717790179789766%",
    "cy": "73.659759482397%",
    "r": 1.290608417939206,
    "animationDelay": "0.3939576035571246s"
  },
  {
    "cx": "68.6450033213775%",
    "cy": "61.81044753991183%",
    "r": 1.5648440450219692,
    "animationDelay": "0.44046237375855s"
  },
  {
    "cx": "72.11859473585855%",
    "cy": "11.980839466662086%",
    "r": 1.906390250331461,
    "animationDelay": "0.9243921981546444s"
  },
  {
    "cx": "87.95839839114375%",
    "cy": "55.182257445268924%",
    "r": 0.5477627024338232,
    "animationDelay": "4.64464033179461s"
  },
  {
    "cx": "97.54651916747925%",
    "cy": "93.86334289963622%",
    "r": 1.5718113922879087,
    "animationDelay": "2.3709030444083257s"
  },
  {
    "cx": "24.087881396847322%",
    "cy": "30.307746370001976%",
    "r": 1.0055041581918511,
    "animationDelay": "3.2322977452531223s"
  },
  {
    "cx": "32.76832852734213%",
    "cy": "80.07748398863232%",
    "r": 1.925161437236749,
    "animationDelay": "2.468906793926633s"
  },
  {
    "cx": "83.52193052462293%",
    "cy": "7.0682969701981735%",
    "r": 1.3383511217748423,
    "animationDelay": "1.186988730424261s"
  },
  {
    "cx": "87.61259706726929%",
    "cy": "61.48906060966872%",
    "r": 0.5346662053764786,
    "animationDelay": "0.2694616217218415s"
  },
  {
    "cx": "47.733145303770044%",
    "cy": "66.02811659423904%",
    "r": 1.7397808437298563,
    "animationDelay": "4.39596450782126s"
  },
  {
    "cx": "53.14823065622478%",
    "cy": "18.88796506822128%",
    "r": 1.1579129305546065,
    "animationDelay": "1.52886930465567s"
  },
  {
    "cx": "89.86662440028621%",
    "cy": "58.792117181948655%",
    "r": 0.6454947127568517,
    "animationDelay": "0.9404854440221644s"
  },
  {
    "cx": "15.202367962218766%",
    "cy": "1.5321383776993436%",
    "r": 1.3249108189336227,
    "animationDelay": "2.061713874972533s"
  },
  {
    "cx": "82.45300307530121%",
    "cy": "2.6020256893755978%",
    "r": 1.3176831068858104,
    "animationDelay": "0.8291457019355242s"
  },
  {
    "cx": "7.237609637687381%",
    "cy": "22.57497316429231%",
    "r": 0.6001614143611965,
    "animationDelay": "4.006301103634861s"
  },
  {
    "cx": "42.558690204953756%",
    "cy": "77.18132010086019%",
    "r": 1.4773379673699962,
    "animationDelay": "2.6477145515053238s"
  },
  {
    "cx": "54.18042745135099%",
    "cy": "1.3386375414456975%",
    "r": 1.2323004527535804,
    "animationDelay": "0.28384890668983864s"
  },
  {
    "cx": "9.019653750488722%",
    "cy": "78.2164432873353%",
    "r": 0.5433326682222855,
    "animationDelay": "0.6212114183372142s"
  },
  {
    "cx": "39.24949403704381%",
    "cy": "29.09602141069798%",
    "r": 1.6525840014471913,
    "animationDelay": "4.723255334225418s"
  },
  {
    "cx": "10.3360317218687%",
    "cy": "34.8075353879651%",
    "r": 1.6620671487707337,
    "animationDelay": "0.7074056459566169s"
  },
  {
    "cx": "47.232265514540785%",
    "cy": "57.47369304079062%",
    "r": 1.3866668617793987,
    "animationDelay": "4.455474541575083s"
  },
  {
    "cx": "79.5014229042748%",
    "cy": "6.698992789928004%",
    "r": 1.3781624395622964,
    "animationDelay": "2.127394024479919s"
  },
  {
    "cx": "58.162169802921724%",
    "cy": "61.72867296554179%",
    "r": 1.8281481696394681,
    "animationDelay": "4.820748294001205s"
  },
  {
    "cx": "58.296328842005884%",
    "cy": "60.94869374809535%",
    "r": 1.087625222364216,
    "animationDelay": "2.63387173083387s"
  },
  {
    "cx": "93.10516178557387%",
    "cy": "76.92991106072623%",
    "r": 1.1983895359534307,
    "animationDelay": "1.8769823476799885s"
  },
  {
    "cx": "40.67135449559658%",
    "cy": "30.729630900424198%",
    "r": 1.5897113601497068,
    "animationDelay": "3.880130168918765s"
  },
  {
    "cx": "81.50180205532934%",
    "cy": "43.29062071016876%",
    "r": 1.2670091813649151,
    "animationDelay": "3.2835002340367305s"
  },
  {
    "cx": "74.03656949515248%",
    "cy": "23.3660004226828%",
    "r": 0.763107121045369,
    "animationDelay": "1.8294967958163977s"
  },
  {
    "cx": "18.025343092797485%",
    "cy": "92.89418003783882%",
    "r": 1.9837167105800282,
    "animationDelay": "2.3117991692065862s"
  },
  {
    "cx": "39.928876483856435%",
    "cy": "96.21299384831654%",
    "r": 0.7569684504780487,
    "animationDelay": "3.566875706988691s"
  },
  {
    "cx": "21.208651878962193%",
    "cy": "20.090612197663305%",
    "r": 1.3633057333892982,
    "animationDelay": "0.1568863731605008s"
  },
  {
    "cx": "38.157343628829295%",
    "cy": "71.02304531563406%",
    "r": 1.103106265817813,
    "animationDelay": "3.394097385396493s"
  },
  {
    "cx": "73.11264798090545%",
    "cy": "5.440522497802247%",
    "r": 1.198460058739139,
    "animationDelay": "4.367868093496253s"
  },
  {
    "cx": "79.5108483687304%",
    "cy": "73.99565769655891%",
    "r": 1.2721096201390316,
    "animationDelay": "0.27867686218555066s"
  },
  {
    "cx": "3.3682951956357954%",
    "cy": "54.39523044535639%",
    "r": 1.8899613797449935,
    "animationDelay": "1.4273024709462157s"
  },
  {
    "cx": "16.219109933933563%",
    "cy": "42.75053804274555%",
    "r": 1.1812734347935496,
    "animationDelay": "1.9163915402463527s"
  },
  {
    "cx": "40.54153494408528%",
    "cy": "94.47964374155976%",
    "r": 1.8796323817572835,
    "animationDelay": "3.061909988593905s"
  },
  {
    "cx": "62.16792951281309%",
    "cy": "36.045090837761286%",
    "r": 1.434299294892971,
    "animationDelay": "1.5231111989983015s"
  },
  {
    "cx": "46.199925466940584%",
    "cy": "98.38901461881169%",
    "r": 1.1842881991240242,
    "animationDelay": "4.689351020363013s"
  },
  {
    "cx": "41.28500136458264%",
    "cy": "38.74260161662597%",
    "r": 1.1252957658105456,
    "animationDelay": "0.7261360732476774s"
  },
  {
    "cx": "53.66533729105698%",
    "cy": "4.695172621507426%",
    "r": 1.0041186498223151,
    "animationDelay": "3.7583134192446277s"
  },
  {
    "cx": "74.70629407807775%",
    "cy": "78.23010343557651%",
    "r": 1.2180935241957798,
    "animationDelay": "0.615784929381793s"
  },
  {
    "cx": "44.55450880446386%",
    "cy": "51.70788661770904%",
    "r": 1.5219324251327135,
    "animationDelay": "4.497805117845096s"
  },
  {
    "cx": "13.88001943287649%",
    "cy": "40.05327985086842%",
    "r": 0.9885779775595629,
    "animationDelay": "3.470573733452742s"
  },
  {
    "cx": "16.13696569624632%",
    "cy": "31.66159139727076%",
    "r": 1.704758473115497,
    "animationDelay": "2.6909029980693564s"
  },
  {
    "cx": "61.898730424461924%",
    "cy": "14.251759080755733%",
    "r": 1.885067225260561,
    "animationDelay": "1.3162711529940874s"
  },
  {
    "cx": "37.183009842958214%",
    "cy": "7.636154435841158%",
    "r": 1.004308957614472,
    "animationDelay": "0.8780130218075799s"
  },
  {
    "cx": "3.580563692845451%",
    "cy": "2.8603450650454887%",
    "r": 0.8630645635236643,
    "animationDelay": "1.860733865479236s"
  },
  {
    "cx": "76.33088388748676%",
    "cy": "34.19306034442842%",
    "r": 1.3505760471739525,
    "animationDelay": "0.16369688967669438s"
  },
  {
    "cx": "37.8754851288198%",
    "cy": "19.359294748746358%",
    "r": 1.0046710423270038,
    "animationDelay": "0.0004222422614819088s"
  },
  {
    "cx": "95.8230210785441%",
    "cy": "31.106487009749518%",
    "r": 1.9517966451825215,
    "animationDelay": "0.769462955666752s"
  },
  {
    "cx": "23.408912648548718%",
    "cy": "69.59653713893627%",
    "r": 0.8867959611358935,
    "animationDelay": "3.4254559113087324s"
  },
  {
    "cx": "52.48946450855483%",
    "cy": "86.97383364676854%",
    "r": 0.7499352896402864,
    "animationDelay": "1.9043878221574373s"
  },
  {
    "cx": "19.68334285874014%",
    "cy": "28.778172764330677%",
    "r": 1.6581769127388273,
    "animationDelay": "1.008366792566946s"
  },
  {
    "cx": "99.22323264396702%",
    "cy": "73.82798722785778%",
    "r": 0.8808103813814259,
    "animationDelay": "4.094603764010595s"
  },
  {
    "cx": "13.88294337431093%",
    "cy": "48.67429205729594%",
    "r": 1.9893526369113133,
    "animationDelay": "2.0864408658850984s"
  },
  {
    "cx": "31.090794290191504%",
    "cy": "94.82929518118046%",
    "r": 0.8472746354965768,
    "animationDelay": "4.1745234193131715s"
  },
  {
    "cx": "58.8292654783505%",
    "cy": "87.0470358962935%",
    "r": 1.748460402739378,
    "animationDelay": "2.217045711062835s"
  },
  {
    "cx": "99.11454139122864%",
    "cy": "30.184325645161802%",
    "r": 1.2142155383052482,
    "animationDelay": "2.819621947095039s"
  },
  {
    "cx": "88.08009665327474%",
    "cy": "79.5172659071131%",
    "r": 1.3603952025753256,
    "animationDelay": "1.998362688096299s"
  },
  {
    "cx": "5.305635606543024%",
    "cy": "37.10940129928417%",
    "r": 1.958868801433108,
    "animationDelay": "4.407070442966814s"
  },
  {
    "cx": "5.210519769822053%",
    "cy": "60.27770595345614%",
    "r": 1.873438267152255,
    "animationDelay": "2.169534040706722s"
  },
  {
    "cx": "99.3031678382938%",
    "cy": "6.612187708153794%",
    "r": 0.5475628795805958,
    "animationDelay": "1.000425321504781s"
  },
  {
    "cx": "19.54097790307263%",
    "cy": "81.79580943453107%",
    "r": 1.4233546547793963,
    "animationDelay": "4.9455730285894495s"
  },
  {
    "cx": "4.568975189071356%",
    "cy": "63.22396208393026%",
    "r": 1.1943275081643794,
    "animationDelay": "4.242548380446491s"
  },
  {
    "cx": "68.9074173189866%",
    "cy": "11.185258158853827%",
    "r": 0.8329223236634774,
    "animationDelay": "0.7180827872785733s"
  },
  {
    "cx": "68.7086762465345%",
    "cy": "99.91166077634685%",
    "r": 0.718475125790635,
    "animationDelay": "4.3627262250812935s"
  },
  {
    "cx": "58.692662992482525%",
    "cy": "69.61944080651217%",
    "r": 1.41546989437246,
    "animationDelay": "3.6528435838606486s"
  },
  {
    "cx": "33.26312834918854%",
    "cy": "7.688033467233302%",
    "r": 0.8775565076394221,
    "animationDelay": "0.1437123599531509s"
  },
  {
    "cx": "91.66328523356837%",
    "cy": "4.411660447765775%",
    "r": 1.4578785765444402,
    "animationDelay": "3.4890425823927016s"
  },
  {
    "cx": "71.73678458142179%",
    "cy": "54.6301550633123%",
    "r": 1.763679132681946,
    "animationDelay": "4.346819824987653s"
  },
  {
    "cx": "83.29838347166414%",
    "cy": "38.60701813349969%",
    "r": 1.6371252764798756,
    "animationDelay": "1.0354570061382606s"
  },
  {
    "cx": "82.21426184276768%",
    "cy": "80.99872060977356%",
    "r": 1.7986170206364407,
    "animationDelay": "4.388608900557837s"
  },
  {
    "cx": "5.620422374402301%",
    "cy": "20.066045111017637%",
    "r": 0.710942882047442,
    "animationDelay": "1.1786491680552469s"
  },
  {
    "cx": "99.78721026208287%",
    "cy": "67.22800057444466%",
    "r": 1.338840638482891,
    "animationDelay": "0.9355634749728647s"
  },
  {
    "cx": "93.93388408785583%",
    "cy": "97.10421743953574%",
    "r": 0.7535172353970929,
    "animationDelay": "4.41967618094692s"
  },
  {
    "cx": "19.599210989178605%",
    "cy": "50.32111782184574%",
    "r": 1.4774175427264011,
    "animationDelay": "1.0901010451406812s"
  },
  {
    "cx": "2.6197980952102684%",
    "cy": "53.312965907379905%",
    "r": 1.0071245154334179,
    "animationDelay": "0.6249652826983321s"
  },
  {
    "cx": "41.493489001385896%",
    "cy": "96.0040986544543%",
    "r": 1.9005537822253769,
    "animationDelay": "0.05554383644339578s"
  },
  {
    "cx": "24.097392728282042%",
    "cy": "67.22274513439788%",
    "r": 1.4608983749169662,
    "animationDelay": "3.40258636016379s"
  },
  {
    "cx": "11.160672519042535%",
    "cy": "1.2255036052688073%",
    "r": 1.174585835470988,
    "animationDelay": "2.3662471984144307s"
  },
  {
    "cx": "75.40094605669498%",
    "cy": "18.49454154597263%",
    "r": 1.3499701316374417,
    "animationDelay": "4.861988589909966s"
  },
  {
    "cx": "23.943412969316146%",
    "cy": "34.14983798566611%",
    "r": 1.5324982735799328,
    "animationDelay": "0.6447295992263824s"
  },
  {
    "cx": "53.472043287030566%",
    "cy": "22.62947038103553%",
    "r": 0.9224033903582666,
    "animationDelay": "3.4957848559377327s"
  },
  {
    "cx": "39.190371276224354%",
    "cy": "88.47490795137645%",
    "r": 1.2743600024982675,
    "animationDelay": "1.1274965850750307s"
  },
  {
    "cx": "90.93470970851372%",
    "cy": "43.820233706860144%",
    "r": 1.0969794371818415,
    "animationDelay": "3.7972949995994973s"
  },
  {
    "cx": "87.90028423819447%",
    "cy": "77.94309728295401%",
    "r": 1.6815450669918013,
    "animationDelay": "1.7856909829775558s"
  },
  {
    "cx": "83.52866503956061%",
    "cy": "58.91275519559789%",
    "r": 0.6590255518591127,
    "animationDelay": "4.10775981759353s"
  },
  {
    "cx": "81.1827781903521%",
    "cy": "15.89379558334809%",
    "r": 0.9154025848437036,
    "animationDelay": "0.026949306957916308s"
  },
  {
    "cx": "3.6240733583758455%",
    "cy": "35.49263863721488%",
    "r": 1.4303844217128847,
    "animationDelay": "3.1099053360156015s"
  },
  {
    "cx": "15.644051600116615%",
    "cy": "36.91593304815272%",
    "r": 0.791740169244367,
    "animationDelay": "3.872337138819959s"
  },
  {
    "cx": "86.85109810320061%",
    "cy": "21.459760469236766%",
    "r": 0.8759099230778883,
    "animationDelay": "2.232457409894566s"
  },
  {
    "cx": "78.32164740725851%",
    "cy": "90.93258762810737%",
    "r": 1.8227921288005944,
    "animationDelay": "2.2312006242731783s"
  },
  {
    "cx": "29.642997315384267%",
    "cy": "93.65956588202953%",
    "r": 0.5015366629662538,
    "animationDelay": "0.59319671673431s"
  },
  {
    "cx": "6.25925129754259%",
    "cy": "22.862758714180643%",
    "r": 0.6988992174974963,
    "animationDelay": "0.7223601628476106s"
  },
  {
    "cx": "15.200008633732853%",
    "cy": "78.26294648966912%",
    "r": 1.7319828101498382,
    "animationDelay": "2.988372750346564s"
  },
  {
    "cx": "55.997249674950524%",
    "cy": "20.271469920134976%",
    "r": 1.8766164786456785,
    "animationDelay": "3.9751559928396474s"
  },
  {
    "cx": "15.667856178042472%",
    "cy": "25.22853180099154%",
    "r": 1.891577337378529,
    "animationDelay": "3.7839325804782344s"
  },
  {
    "cx": "22.109008227989403%",
    "cy": "71.83058623832157%",
    "r": 1.0893877008418555,
    "animationDelay": "1.1378383105869438s"
  },
  {
    "cx": "98.25326974097248%",
    "cy": "96.35985155629794%",
    "r": 0.7167532736254342,
    "animationDelay": "3.3342125846515778s"
  },
  {
    "cx": "81.86930864425297%",
    "cy": "39.52983757800852%",
    "r": 1.9473883386016086,
    "animationDelay": "4.878050340255672s"
  },
  {
    "cx": "81.3574298522615%",
    "cy": "75.07231131467356%",
    "r": 0.8572064353782543,
    "animationDelay": "1.9057074871303858s"
  },
  {
    "cx": "18.64789067073016%",
    "cy": "95.21710564990096%",
    "r": 1.2277510093843151,
    "animationDelay": "3.1985671357558765s"
  },
  {
    "cx": "30.98834234465777%",
    "cy": "30.03501447147867%",
    "r": 1.6717989623746319,
    "animationDelay": "0.2705022850460803s"
  },
  {
    "cx": "76.90675327409305%",
    "cy": "56.01139396237556%",
    "r": 1.7864587121043092,
    "animationDelay": "1.6300344644017128s"
  },
  {
    "cx": "22.313483892517727%",
    "cy": "52.67938285572706%",
    "r": 1.4818843177122711,
    "animationDelay": "3.013516503870337s"
  },
  {
    "cx": "97.27073632432877%",
    "cy": "89.98257541449021%",
    "r": 1.6942494207982084,
    "animationDelay": "1.1540759136353695s"
  },
  {
    "cx": "4.737627362118291%",
    "cy": "13.617242403100516%",
    "r": 1.9984736116067303,
    "animationDelay": "4.117969311101856s"
  },
  {
    "cx": "94.97427783353665%",
    "cy": "58.60865972873486%",
    "r": 0.6898471601084805,
    "animationDelay": "1.175124371125299s"
  },
  {
    "cx": "77.84006423486716%",
    "cy": "15.017102524543159%",
    "r": 1.4750788710301215,
    "animationDelay": "4.4565197178280105s"
  },
  {
    "cx": "27.758515127485815%",
    "cy": "24.108119242830007%",
    "r": 1.602236409658551,
    "animationDelay": "1.2321142823190878s"
  },
  {
    "cx": "19.647904544548634%",
    "cy": "0.5299096931911329%",
    "r": 1.601677756107633,
    "animationDelay": "2.77624857490792s"
  },
  {
    "cx": "88.21285757929182%",
    "cy": "88.37130730039966%",
    "r": 1.3219539334666992,
    "animationDelay": "0.5208912232038876s"
  },
  {
    "cx": "8.960217242698931%",
    "cy": "33.93043701215066%",
    "r": 0.9902141230560939,
    "animationDelay": "1.8878438460270153s"
  },
  {
    "cx": "45.36905767272934%",
    "cy": "78.30003192219499%",
    "r": 1.5294801135751421,
    "animationDelay": "2.2334194686281252s"
  },
  {
    "cx": "53.202406589406536%",
    "cy": "0.74658372948333%",
    "r": 0.6591019465040151,
    "animationDelay": "2.7557251412676678s"
  },
  {
    "cx": "32.87779996645859%",
    "cy": "38.73545797921118%",
    "r": 1.8657977940344652,
    "animationDelay": "1.095535573895906s"
  },
  {
    "cx": "58.02359904733609%",
    "cy": "33.76558995477441%",
    "r": 1.2542411551801027,
    "animationDelay": "3.7586600117376214s"
  },
  {
    "cx": "91.56065781969549%",
    "cy": "87.12342926839058%",
    "r": 1.4620128096509548,
    "animationDelay": "2.007886837038387s"
  },
  {
    "cx": "60.444883646861136%",
    "cy": "28.30897215899453%",
    "r": 0.5295970755054462,
    "animationDelay": "1.685875121372088s"
  },
  {
    "cx": "4.947237668618665%",
    "cy": "62.674450619917366%",
    "r": 1.2774942799542615,
    "animationDelay": "1.076487945090383s"
  },
  {
    "cx": "31.766556342766993%",
    "cy": "58.272468456285644%",
    "r": 1.0557323582391374,
    "animationDelay": "2.6905818334920086s"
  },
  {
    "cx": "61.35942088681541%",
    "cy": "22.755124354030443%",
    "r": 0.7122853124283041,
    "animationDelay": "4.082728511302916s"
  },
  {
    "cx": "68.61104194964902%",
    "cy": "86.43596935642042%",
    "r": 1.4758500152364364,
    "animationDelay": "2.2378766754384993s"
  },
  {
    "cx": "95.5618515954071%",
    "cy": "37.44128765226886%",
    "r": 0.9384340431982238,
    "animationDelay": "3.67754081555822s"
  },
  {
    "cx": "38.231677900832636%",
    "cy": "84.84879753726533%",
    "r": 1.545606084123585,
    "animationDelay": "3.3968751288014722s"
  },
  {
    "cx": "14.88676339004089%",
    "cy": "2.3605174379647043%",
    "r": 1.3352777389383115,
    "animationDelay": "3.1501467009270967s"
  },
  {
    "cx": "34.079974562880146%",
    "cy": "99.93853613868822%",
    "r": 1.3703650657943045,
    "animationDelay": "2.401626747266752s"
  },
  {
    "cx": "12.054311514623773%",
    "cy": "87.07368051506892%",
    "r": 1.1240267753834408,
    "animationDelay": "2.6038784934773105s"
  },
  {
    "cx": "38.518232726087746%",
    "cy": "20.252631049232516%",
    "r": 1.9192470261745882,
    "animationDelay": "3.8037693574710163s"
  },
  {
    "cx": "82.61961927211334%",
    "cy": "14.954860493430733%",
    "r": 1.2397638937963564,
    "animationDelay": "0.11506460123280715s"
  },
  {
    "cx": "68.5735801308907%",
    "cy": "58.54486523747826%",
    "r": 1.3651643390441728,
    "animationDelay": "4.374766260193663s"
  },
  {
    "cx": "60.654650214919535%",
    "cy": "86.89395910055234%",
    "r": 1.5151549413256604,
    "animationDelay": "4.226324957138843s"
  },
  {
    "cx": "19.86719705156663%",
    "cy": "11.209558977382539%",
    "r": 0.7056249474232702,
    "animationDelay": "1.8996836964490371s"
  },
  {
    "cx": "77.391356429779%",
    "cy": "81.9706137533407%",
    "r": 0.91945838577812,
    "animationDelay": "3.8423760676656773s"
  },
  {
    "cx": "11.295564462176767%",
    "cy": "60.77436524303237%",
    "r": 0.567812600820338,
    "animationDelay": "3.8314642481815464s"
  },
  {
    "cx": "17.016874447524486%",
    "cy": "86.38478753250412%",
    "r": 0.5002480084648492,
    "animationDelay": "0.04406742618814352s"
  },
  {
    "cx": "21.103301099548656%",
    "cy": "20.94187745164644%",
    "r": 0.9581678456185954,
    "animationDelay": "2.7013891606682963s"
  },
  {
    "cx": "28.532559306306716%",
    "cy": "71.44939255336995%",
    "r": 1.3388323379640013,
    "animationDelay": "2.6255141191089737s"
  },
  {
    "cx": "65.48457960161204%",
    "cy": "72.84429798418716%",
    "r": 1.0420961240495235,
    "animationDelay": "2.3939768141787665s"
  },
  {
    "cx": "19.509864966528667%",
    "cy": "23.425250527444263%",
    "r": 1.0808057923108023,
    "animationDelay": "2.7540062878080795s"
  },
  {
    "cx": "96.80607439006961%",
    "cy": "10.686831247606698%",
    "r": 1.0110410571177626,
    "animationDelay": "0.07326383067660314s"
  },
  {
    "cx": "8.28358241185545%",
    "cy": "49.56317432611406%",
    "r": 1.5653542638953946,
    "animationDelay": "4.986447218084631s"
  },
  {
    "cx": "15.68892461756688%",
    "cy": "96.64873033987456%",
    "r": 1.4105717419731885,
    "animationDelay": "3.369583339746832s"
  },
  {
    "cx": "62.48755045626062%",
    "cy": "42.37579549833721%",
    "r": 1.7244878062951206,
    "animationDelay": "3.677606584484768s"
  },
  {
    "cx": "12.458985453981208%",
    "cy": "2.2008019521752464%",
    "r": 0.6134549442968328,
    "animationDelay": "0.034175569319502275s"
  },
  {
    "cx": "10.793902440962832%",
    "cy": "49.244598547316045%",
    "r": 0.5015460964859841,
    "animationDelay": "0.1661798144177462s"
  },
  {
    "cx": "47.7080637065872%",
    "cy": "99.44569525383737%",
    "r": 1.3894167678615301,
    "animationDelay": "3.5637169311837633s"
  },
  {
    "cx": "64.2142596592822%",
    "cy": "43.864469340429444%",
    "r": 0.5085803568626347,
    "animationDelay": "0.5111810077685819s"
  },
  {
    "cx": "33.626142764103605%",
    "cy": "77.51888680722723%",
    "r": 0.6913970155673209,
    "animationDelay": "3.3933402863274686s"
  },
  {
    "cx": "43.054913132666115%",
    "cy": "25.4277170922091%",
    "r": 1.3844249354329696,
    "animationDelay": "4.884789096984789s"
  },
  {
    "cx": "91.75151018617271%",
    "cy": "7.359683614887347%",
    "r": 1.8196690257507178,
    "animationDelay": "3.478546892188116s"
  },
  {
    "cx": "30.394090661867203%",
    "cy": "64.30454679281179%",
    "r": 1.7552193250101358,
    "animationDelay": "1.360325941367071s"
  },
  {
    "cx": "43.465769144448664%",
    "cy": "52.85471294435071%",
    "r": 1.0675058128444472,
    "animationDelay": "2.3883388141662687s"
  }
]